import React, { useContext } from "react";
// router, intl
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
// component
import NotLogIn from "./notLogin/NotLogIn";
import GroupMember from "./groupMember/GroupMember";
import GroupList from "./groupList/GroupList";
import { StoreContext } from "../../../../../store/StoreProvider";
// hook
import useModulePublic from "../../../../hooks/useModulePublic";
import useLocaleRoute from "../../../../../common/hooks/useLocaleRoute";
// config,utils,css
import fireAuth from "../../../../../api/firebase/auth/utils";
import urls from "../../../../../api/project/ApiUrls";

const GroupTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);
  // const isLoggedIn = true;

  return (
    <Box>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="body1"
          sx={{
            color: "#fff",
          }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--group-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.grouptool.title",
            defaultMessage: "團隊",
          })}
        </Typography>
      </Box>
      {isLoggedIn && <GroupMember />}
      {isLoggedIn && <GroupList />}
      {!isLoggedIn && <NotLogIn />}
    </Box>
  );
};

export default GroupTool;
